export const AppSettings = {
    AppEnabledOrganizationId: 'appEnabledOrganizationId',
    Theme: 'appTheme',
    AgencySelectionPopedUp: 'agencySelectionPoppedUp',
  };
  